import { ClipboardCheck, Flag, Users } from 'lucide-react';
import type { HqHistoricalSummary } from '@kop/contracts';

const definitions = {
  emphasis: { title: '안전강조주간', icon: Flag, columns: ['행사 항목', '계획', '실시', '결과'],
    rows: ['대표이사 사업장 안전점검', '비상대피훈련', '안전 캠페인', '공모전'] },
  meetings: { title: '안전보건 월회의', icon: Users, columns: ['대상 월', '회의일', '회의자료', '회의록'],
    rows: Array.from({ length: 12 }, (_, month) => `${month + 1}월`) },
  inspections: { title: '본사 지도점검', icon: ClipboardCheck, columns: ['부문', '지도점검 계획', '실시', '예정'],
    rows: ['생산부문', '시공부문', '해양부문'] },
} as const;

export type HeadquartersControlPageId = keyof typeof definitions;

/** Dedicated HQ workspaces are explicit about unimplemented authoring; no fabricated records. */
export function HeadquartersControlPage({ page, year, historical, onOpenRecord }: {
  page: HeadquartersControlPageId; year: number; half: number;
  historical?: HqHistoricalSummary | null; onOpenRecord?: (id: string) => void;
}) {
  const definition = definitions[page], Icon = definition.icon;
  if (historical?.year === year) {
    const open = (id: string) => <button type="button" onClick={() => onOpenRecord?.(id)} disabled={!onOpenRecord}>내용 보기</button>;
    return <section className="hqv-detail-page hqv-control-page" aria-label={`본사 ${definition.title}`}>
      <header><div><Icon size={21}/><h2>{year}년 {definition.title}</h2></div><span className="hqv-control-status">등록 보고자료</span></header>
      {page === 'meetings' ? <table><thead><tr><th>대상 월</th><th>회차</th><th>회의일</th><th>내용</th></tr></thead><tbody>{historical.monthlyMeetings.map(row => <tr key={row.id}><th>{row.month}</th><td>{row.round}차</td><td>{row.meetingDate ?? '일자 확인 필요'}</td><td>{open(row.id)}</td></tr>)}</tbody></table>
        : page === 'emphasis' ? <table><thead><tr><th>반기</th><th>행사</th><th>보고일</th><th>내용</th></tr></thead><tbody>{historical.emphasis.map(row => <tr key={row.id}><th>{row.half === 1 ? '상반기' : '하반기'}</th><td>제{row.round}회 안전강조주간</td><td>{row.reportDate}</td><td>{open(row.id)}</td></tr>)}</tbody></table>
          : <table><thead><tr><th>자료</th><th>계획일</th><th>실시일</th><th>지적 / 조치</th><th>내용</th></tr></thead><tbody>{historical.inspections.map(row => <tr key={row.id}><th>{row.title}</th><td>{row.plannedFrom ?? '—'}</td><td>{row.actualFrom ?? '미확정'}</td><td>{row.findings ?? '—'} / {row.actions ?? '미확정'}</td><td>{open(row.id)}</td></tr>)}</tbody></table>}
    </section>;
  }
  return <section className="hqv-detail-page hqv-control-page" aria-label={`본사 ${definition.title}`}>
    <header><div><Icon size={21}/><h2>{year}년 {definition.title}</h2></div>
      <span className="hqv-control-status">작성 기능 준비 중</span></header>
    <table><thead><tr>{definition.columns.map(column => <th key={column} scope="col">{column}</th>)}</tr></thead>
      <tbody>{definition.rows.map(row => <tr key={row}><th scope="row">{row}</th><td>—</td><td>—</td><td>—</td></tr>)}</tbody></table>
  </section>;
}
